var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExpand = function SvgExpand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.295 19.87c0 .415.335.75.75.75h4.714a.75.75 0 0 0 0-1.5H5.855l4.613-4.612a.75.75 0 0 0-1.06-1.06L4.794 18.06v-2.903a.75.75 0 0 0-1.5 0v4.714Zm16.66-16.66a.75.75 0 0 1 .75.75v4.715a.75.75 0 1 1-1.5 0V5.772l-4.613 4.612a.75.75 0 0 1-1.06-1.06l4.613-4.613H15.24a.75.75 0 0 1 0-1.5h4.713Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExpand);
export default ForwardRef;